function dismissAlert(alert) {
  const alertEncoded = alert.dataset.alertEncoded;

  // Set cookie
  const alertCookie = 'alert-hidden-' + alertEncoded + '=true ;max-age=1209600';
  document.cookie = alertCookie;

  // Hide alert
  alert.classList.add('hidden');
}

function setupAlert() {
  const closeBtn = document.querySelector('.js-alert-close');

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      const alert = closeBtn.closest('.js-alert');

      dismissAlert(alert);
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  setupAlert();
});
